// Mock data for A Quality Handyman LLC landing page

export const heroData = {
  businessName: "A Quality",
  businessSubtitle: "Residential and Commercial Handyman Services",
  logo: "https://customer-assets.emergentagent.com/job_repair-showcase-4/artifacts/pnlg4xvu_Screenshot_20260205_155848_Facebook.jpg",
  tagline: "Expert Solutions for Every Home Project",
  description: "Professional handyman services you can trust. From quick fixes to complete renovations, we handle it all with precision and care.",
  ctaText: "Get Free Quote"
};

export const servicesData = [
  {
    id: 1,
    title: "General Repairs",
    description: "Quick fixes for everyday household issues. Door adjustments, drywall repairs, fixture installations, and more.",
    icon: "Wrench",
    features: ["Door & Window Repairs", "Drywall & Painting", "Furniture Assembly", "General Maintenance"]
  },
  {
    id: 2,
    title: "Electrical Services",
    description: "Safe and certified electrical work for your home. Lighting, outlets, switches, and electrical upgrades.",
    icon: "Zap",
    features: ["Light Fixture Installation", "Outlet & Switch Repair", "Ceiling Fan Installation", "Electrical Troubleshooting"]
  },
  {
    id: 3,
    title: "Plumbing",
    description: "Reliable plumbing services to keep your home running smoothly. Leak repairs, fixture installations, and more.",
    icon: "Droplet",
    features: ["Faucet Installation", "Leak Repairs", "Toilet Repairs", "Drain Cleaning"]
  },
  {
    id: 4,
    title: "Carpentry",
    description: "Custom woodwork and carpentry services. Shelving, trim work, deck repairs, and custom built-ins.",
    icon: "Hammer",
    features: ["Custom Shelving", "Trim & Molding", "Deck Repairs", "Cabinet Installation"]
  },
  {
    id: 5,
    title: "Painting",
    description: "Professional interior and exterior painting services. Transform your space with expert color application.",
    icon: "Paintbrush",
    features: ["Interior Painting", "Exterior Painting", "Cabinet Refinishing", "Wallpaper Removal"]
  },
  {
    id: 6,
    title: "Home Maintenance",
    description: "Comprehensive maintenance packages to keep your home in top condition year-round.",
    icon: "Home",
    features: ["Seasonal Inspections", "Preventive Maintenance", "Gutter Cleaning", "Power Washing"]
  }
];

export const testimonialsData = [
  {
    id: 1,
    name: "Stan Agustin",
    role: "Homeowner",
    content: "Recently we had a serious problem with our eave. Paolo came to look at the problem and explained in detail what needed to be done. What impressed me even more was the care and quality of work Cody displayed. I am so pleased with this company. They did a quality job at a reasonable price. I cannot stress enough how grateful I am!",
    rating: 5,
    avatar: "SA"
  },
  {
    id: 2,
    name: "Devon Warner",
    role: "Homeowner",
    content: "I just bought my new house and needed some shelving removed, Paolo came out the next day and had the job done in about 10 minutes. Super friendly and gave me a great quote on getting brand new exterior doors installed. I would definitely recommend their service 100%!",
    rating: 5,
    avatar: "DW"
  },
  {
    id: 3,
    name: "Alan Geuder",
    role: "Homeowner",
    content: "Excellent service, excellent work. Paolo is super customer focused. Explained different options but didn't try to upsell me. Arrived when planned, finished when planned. They exceeded my expectations. Highly recommended!",
    rating: 5,
    avatar: "AG"
  },
  {
    id: 4,
    name: "EJ K",
    role: "Homeowner",
    content: "Top notch handyman. Quick efficient and priced fairly. Great communication and easy to work with. Excellent outcomes. 💯 recommended. Lets go!",
    rating: 5,
    avatar: "EK"
  }
];

export const galleryData = [
  {
    id: 1,
    image: "https://customer-assets.emergentagent.com/job_repair-showcase-4/artifacts/ee0389nn_20251030_111750.jpg",
    title: "Kitchen Cabinets - Before",
    category: "Painting"
  },
  {
    id: 2,
    image: "https://customer-assets.emergentagent.com/job_repair-showcase-4/artifacts/fz2exw3n_20251226_141741.jpg",
    title: "Professional Paint Equipment",
    category: "Painting"
  },
  {
    id: 3,
    image: "https://customer-assets.emergentagent.com/job_repair-showcase-4/artifacts/rvqpbjrh_IMG_20251229_200659.jpg",
    title: "Cabinet Painting in Progress",
    category: "Painting"
  },
  {
    id: 4,
    image: "https://customer-assets.emergentagent.com/job_repair-showcase-4/artifacts/qycz6uk2_IMG_20251229_200628.jpg",
    title: "Kitchen Transformation Process",
    category: "Painting"
  },
  {
    id: 5,
    image: "https://customer-assets.emergentagent.com/job_repair-showcase-4/artifacts/cvveac3r_20251206_113028.jpg",
    title: "Detailed Cabinet Work",
    category: "Painting"
  },
  {
    id: 6,
    image: "https://customer-assets.emergentagent.com/job_repair-showcase-4/artifacts/3s9ron7s_IMG_20260119_115301.png",
    title: "Kitchen Cabinets - After",
    category: "Painting"
  }
];

export const contactInfo = {
  phone: "(505) 219-7816",
  email: "admin@aqualityhandyman.com",
  address: "Albuquerque, NM (service-area business)",
  hours: "24/7 - 365 Days a Year"
};
